/* eslint-disable arrow-parens */
import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import NaturePeopleIcon from '@material-ui/icons/NaturePeople';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import AssessmentIcon from '@material-ui/icons/Assessment';
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  makeStyles
} from '@material-ui/core';
import {
  BarChart as BarChartIcon,
  ShoppingBag as ShoppingBagIcon,
  User as UserIcon
} from 'react-feather';
import NavItem from './NavItem';

const user = {
  avatar: '/static/images/user.png',
  name: localStorage.getItem('name') 
};

const adminItems = [
  {
    href: '/zhs/web',
    icon: BarChartIcon,
    title: 'Dashboard'
  },
  {
    href: '/zhs/web/profile',
    icon: UserIcon,
    title: 'Profile'
  },
  {
    href: '/zhs/web/tasks',
    icon: ShoppingBagIcon,
    title: 'Tasks'
  },
  {
    href: '/zhs/web/clients',
    icon: NaturePeopleIcon,
    title: 'Clients'
  },
  {
    href: '/zhs/web/accounts',
    icon: SupervisorAccountIcon,
    title: 'Accounts'
  }
];

const staffItems = [
  {
    href: '/zhs/web',
    icon: BarChartIcon,
    title: 'Dashboard'
  },
  {
    href: '/zhs/web/profile',
    icon: UserIcon,
    title: 'Profile'
  },
  {
    href: '/zhs/web/tasks',
    icon: ShoppingBagIcon,
    title: 'Tasks'
  },
  {
    href: '/zhs/web/report',
    icon: AssessmentIcon,
    title: 'Report'
  }
];

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

const NavBar = ({ onMobileClose, openMobile }) => {
  const classes = useStyles();
  const location = useLocation();
  const [admin, setAdmin] = useState(false);

  const interval = setInterval(() => {
    if (
      localStorage.getItem('role') !== null ||
      localStorage.getItem('role') !== undefined
    ) {
      if (localStorage.getItem('role') === 'ROLE_ADMIN') {
        setAdmin(true);
      } else {
        setAdmin(false);
      }
      clearInterval(interval);
    }
  }, 50);

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <Box alignItems="center" display="flex" flexDirection="column" p={2}>
        <Avatar
          className={classes.avatar}
          component={RouterLink}
          src={user.avatar}
          to="/zhs/web/profile"
        />
        <Typography className={classes.name} color="textPrimary" variant="h5">
          {localStorage.getItem('name')}
        </Typography>
      </Box>
      <Divider />
      <Box p={2}>
        {admin === true ? (
          <List>
            {adminItems.map(item => (
              <NavItem
                href={item.href}
                key={item.title}
                title={item.title}
                icon={item.icon}
              />
            ))}
          </List>
        ) : (
          <List>
            {staffItems.map(item => (
              <NavItem
                href={item.href}
                key={item.title}
                title={item.title}
                icon={item.icon}
              />
            ))}
          </List>
        )}
      </Box>
      <Box flexGrow={1} />
      <Box p={2} m={2} bgcolor="background.dark">
        <Box display="flex" justifyContent="center" mt={2} />
      </Box>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default NavBar;
